import React from 'react';
import { Link } from 'react-router-dom';
import { ASK_PATH } from '@/constants/appRoutes';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import logoLightUrl from '@/assets/brand/rcm-library-logo-light.svg';
import logoDarkUrl from '@/assets/brand/rcm-library-logo-dark.svg';

interface ShellBrandLogoProps {
  className?: string;
  /** `nav` — header lockup. `compact` — narrower lockup for short viewports. */
  size?: 'default' | 'compact' | 'nav';
  /** @deprecated Prefer `size="compact"` */
  compact?: boolean;
  /** When false, render as a non-interactive brand mark (e.g. auth pages). */
  linked?: boolean;
}

export function ShellBrandLogo({
  className,
  size,
  compact = false,
  linked = true,
}: ShellBrandLogoProps) {
  const { resolvedTheme } = useTheme();
  const resolvedSize = size ?? (compact ? 'compact' : 'default');
  const content = (
    <img
      src={resolvedTheme === 'dark' ? logoDarkUrl : logoLightUrl}
      alt=""
      className={cn(
        'block h-auto w-auto object-contain object-left',
        resolvedSize === 'nav' && 'max-h-12 w-[200px]',
        resolvedSize === 'compact' && 'max-h-9 w-[148px]',
        resolvedSize === 'default' && 'max-h-14 w-[220px]',
      )}
      width={1343}
      height={350}
      decoding="async"
    />
  );

  if (!linked) {
    return (
      <div className={cn('flex items-center min-w-0', className)} role="img" aria-label="RCM Library">
        {content}
      </div>
    );
  }

  return (
    <Link
      to={ASK_PATH}
      className={cn('flex items-center min-w-0', className)}
      aria-label="RCM Library home"
    >
      {content}
    </Link>
  );
}
